/*
 * Copyright (c) 2024. Tooling Team
 */

import React from "react";
import PropTypes from "prop-types";
import { LoadingOverlay } from "@uhg-abyss/web/ui/LoadingOverlay";
import { MintHeader } from "../navigation/MintHeader";

export const AuthLoading = (props) => (
  <div>
    <MintHeader globalNav={false}></MintHeader>
    <div className="auth-loading">
      <LoadingOverlay
        isLoading={true}
        loadingTitle={props.loadingText}
        ariaLoadingLabel={props.loadingText}
      />
    </div>
  </div>
);

AuthLoading.propTypes = {
  loadingText: PropTypes.string,
};

AuthLoading.defaultProps = {
  loadingText: "Authenticating...",
};
